import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.667 10.083v7.334A1.833 1.833 0 0 0 5.5 19.25h11a1.833 1.833 0 0 0 1.833-1.833v-7.334",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11 5.042a3.208 3.208 0 0 0-3.208-3.209 2.292 2.292 0 1 0 0 4.584H11m0-1.375v1.375m0-1.375a3.208 3.208 0 0 1 3.208-3.209 2.292 2.292 0 0 1 0 4.584H11",
  stroke: "currentColor",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11 10.083v9.167M2.75 6.416h16.5v3.667H2.75V6.416Z",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }